
<template>
  <div>
    <CHeader
      data-aos="fade-down"
      data-aos-easing="linear"
      data-aos-duration="1500"
    >
      <CHeaderBrand class="mx-auto" to="/en">
        <img
          src="../../assets/img/pickiddologolargesizewhite.png"
          height="48px"
          class="m-2"
        />
      </CHeaderBrand>

      <CDropdown color="light" class="m-2 d-sm-flex d-md-none" :caret="false">
        <template #toggler-content>
          <CIcon name="cil-justify-center" />
        </template>
        <!-- <CDropdownItem
          style="width: 100% !important"
          href="https://pickiddo.com/about"
        >
          ABOUT US</CDropdownItem
        >
        <CDropdownItem to="/Package">PRICING</CDropdownItem>
        <CDropdownItem href="https://pickiddo.com/Tuition/UserGuide"
          >TUTORIAL</CDropdownItem
        > -->
        <CDropdownItem to="/Package">PRICING</CDropdownItem>
        <CDropdownItem to="/Partner">JOIN AS PARTNER</CDropdownItem>
        <CDropdownItem to="/SearchTutor">
          <CButton color="danger" size="sm" shape="pill"
            >REGISTER</CButton
          ></CDropdownItem
        >
      </CDropdown>

      <CHeaderNav class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3"> </CHeaderNavItem>
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/"> HOMEPAGE </CHeaderNavLink>
        </CHeaderNavItem>
        <!-- <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/about" exact>
            ABOUT US
          </CHeaderNavLink>
        </CHeaderNavItem> -->
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/Package">
            PRICING
          </CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/Partner">
            JOIN AS PARTNER
          </CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink to="/SearchTutor">
            <CButton color="danger" size="sm" shape="pill"
              >REGISTER</CButton
            ></CHeaderNavLink
          >
        </CHeaderNavItem>
      </CHeaderNav>
    </CHeader>
    <CJumbotron
      class="custom-jumbotron d-sm-down-none"
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <CContainer>
        <CRow>
          <CCol
            sm="12"
            lg="12"
            class="element-50 mt-5 text-left custom-center-pro"
          >
            <div>
              <!-- <h1 style="font-weight: 400" class="display-1 text-white">
                <strong>Be our partner and earn more</strong>
              </h1> -->
              <h1
                style="font-weight: 400"
                class="display-1 text-white custom-font"
              >
                <strong>Be our partner and earn more</strong>
              </h1>

              <h5 class="display-5 text-white custom-font">
                TUITION MANAGEMENT PLATFORM
              </h5>
            </div>

            <a href="https://pickiddo.com/PICKIDDO_FE/#/RegisterProClass">
              <CButton
                color="info"
                class="mt-5"
                size="lg"
                style="width: 200px; height: 70px"
                >REGISTER NOW</CButton
              >

              <CButton
                color="primary"
                class="mt-5 ml-1"
                size="lg"
                style="width: 200px; height: 70px; background: #000"
                >LEARN MORE</CButton
              >
            </a>
            <br /><br />
            <br /><br />
          </CCol>
        </CRow>
      </CContainer>
    </CJumbotron>

    <CJumbotron
      class="d-md-none mb-0"
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <CContainer>
        <CRow>
          <CCol
            sm="12"
            lg="12"
            class="element-50 mt-5 text-left custom-center-pro"
          >
            <div>
              <!-- <h1 style="font-weight: 400" class="display-1 text-white">
                <strong>Be our partner and earn more</strong>
              </h1> -->
              <h1
                style="font-weight: 400"
                class="display-5 text-white d-md-none custom-font"
              >
                <strong>Be our partner and earn more</strong>
              </h1>

              <h5 class="display-5 text-white custom-font">
                TUITION MANAGEMENT PLATFORM
              </h5>
            </div>

            <a href="https://pickiddo.com/PICKIDDO_FE/#/RegisterProClass">
              <CButton
                color="info"
                class="mt-5"
                size="lg"
                style="width: 200px; height: 70px"
                >REGISTER NOW</CButton
              >

              <CButton
                color="primary"
                class="mt-5 ml-1"
                size="lg"
                style="width: 200px; height: 70px; background: #000"
                >LEARN MORE</CButton
              >
            </a>
            <br /><br />
            <br /><br />
          </CCol>
        </CRow>
      </CContainer>
    </CJumbotron>
    <CCol style="background: #192e8b" sm="12" lg="12">
      <CRow>
        <CCol sm="12" lg="12">
          <img
            style="background-size: cover;
    color: rgb(255, 255, 255);
    left: 0px;
    right: 0px;
    width: 100%;
}"
            src="../../assets/img/bg4.png"
          />
        </CCol>
        <CCol style="background: #233dff" sm="6" lg="6">
          <h1
            class="mt-5 ml-5 mb-5 display-3 text-white custom-font"
            data-aos="fade-up"
          >
            About <br />
            Platform
          </h1>
        </CCol>
        <CCol style="background: #fff" sm="6" lg="6">
          <h3
            class="display-5-custom mt-5 ml-5 mr-5 mb-5 custom-font"
            data-aos="fade-up"
          >
            Pickiddo Partner program is Tuition Management Platform to offers
            the best one-stop solution for your tuition either offline (physical
            tuition center) or online tuition. We also provide support if you
            want to migrate from offline to an online learning platform. Join
            us!
          </h3>
        </CCol>
      </CRow>
    </CCol>

    <CCol style="bacground-color: rgb(240, 240, 240)" sm="12" lg="12">
      <h1 class="custom-pro-title mt-5 text-center custom-font">
        Offer features
      </h1>
      <h5 class="display-5 text-center custom-font mt-5 mb-5">
        Pickiddo provide many features to provide convenience to tuition <br />
        owners who want to run this tuition whether in the form of offline,
        online or hybrid
      </h5>

      <CRow>
        <CCol sm="4" lg="4" class="p-0">
          <img
            style="max-width: 100%"
            src="../../assets/img/fe2.jpg"
            data-aos="fade-up"
          />
          <div style="background: #233dff" class="bottom-left">
            <h1 class="ml-2 mr-2 custom-font" data-aos="fade-up">
              Physical Class
            </h1>
          </div>
        </CCol>
        <CCol sm="4" lg="4" class="p-0">
          <img
            style="max-width: 100%"
            src="../../assets/img/bgstudent.png"
            data-aos="fade-up"
          />
          <div style="background: #233dff" class="bottom-left">
            <h1 class="ml-2 mr-2 custom-font" data-aos="fade-up">
              Online Class
            </h1>
          </div>
        </CCol>
        <CCol sm="4" lg="4" class="p-0">
          <img
            style="max-width: 100%"
            src="../../assets/img/bg7.png"
            data-aos="fade-up"
          />
          <div style="background: #233dff" class="bottom-left">
            <h1 class="ml-2 mr-2 custom-font" data-aos="fade-up">Web & Apps</h1>
          </div>
        </CCol>
      </CRow>
    </CCol>

    <CCol style="bacground-color: rgb(240, 240, 240)" sm="12" lg="12">
      <h1 class="custom-pro-title mt-5 text-center custom-font">Features</h1>
      <CContainer>
        <CRow class="m-4">
          <CCol sm="3" lg="3" class="p-2 text-center">
            <img
              style="max-width: 130px"
              src="../../assets/img/fes1.png"
              data-aos="fade-up"
              class="text-center"
            />
            <h5 class="text-center custom-font">Schedule</h5>
            <h5 class="text-center text-black custom-font">
              Monitor Learning class schedule anytime and anywhere
            </h5>
          </CCol>
          <CCol sm="3" lg="3" class="p-2 text-center">
            <img
              style="max-width: 130px"
              src="../../assets/img/fes2.png"
              data-aos="fade-up"
            />
            <h5 class="text-center custom-font">Subject</h5>
            <h5 class="text-center text-black custom-font">
              Set schedule and assign teacher on the subject
            </h5>
          </CCol>
          <CCol sm="3" lg="3" class="p-2 text-center">
            <img
              style="max-width: 130px"
              src="../../assets/img/fes3.png"
              data-aos="fade-up"
            />
            <h5 class="text-center custom-font">Attendance</h5>
            <h5 class="text-center text-black custom-font">
              Record attendance student and teacher on the system
            </h5>
          </CCol>
          <CCol sm="3" lg="3" class="p-2 text-center">
            <img
              style="max-width: 130px"
              src="../../assets/img/fes4.png"
              data-aos="fade-up"
            />
            <h5 class="text-center custom-font">Payment</h5>
            <h5 class="text-center text-black custom-font">
              Payment can be made by manual or online
            </h5>
          </CCol>

          <CCol sm="3" lg="3" class="p-2 text-center">
            <img
              style="max-width: 130px"
              src="../../assets/img/fes5.png"
              data-aos="fade-up"
            />
            <h5 class="text-center custom-font">Package</h5>
            <h5 class="text-center text-black custom-font">
              Subscribe package available on the system
            </h5>
          </CCol>
          <CCol sm="3" lg="3" class="p-2 text-center">
            <img
              style="max-width: 130px"
              src="../../assets/img/fes6.png"
              data-aos="fade-up"
            />
            <h5 class="text-center custom-font">Student</h5>
            <h5 class="text-center text-black custom-font">
              Student information can be updated anytime
            </h5>
          </CCol>
          <CCol sm="3" lg="3" class="p-2 text-center">
            <img
              style="max-width: 130px"
              src="../../assets/img/fes7.png"
              data-aos="fade-up"
            />
            <h5 class="text-center custom-font">Teacher</h5>
            <h5 class="text-center text-black custom-font">
              Record pay slip salary and can be print by own
            </h5>
          </CCol>
          <CCol sm="3" lg="3" class="p-2 text-center">
            <img
              style="max-width: 130px"
              src="../../assets/img/fes8.png"
              data-aos="fade-up"
            />
            <h5 class="text-center custom-font">Access Card</h5>
            <h5 class="text-center text-black custom-font">
              Access Card attendance by using card can installed
            </h5>
          </CCol>
        </CRow>
      </CContainer>
    </CCol>

    <CCol sm="12" lg="12" class="mt-2">
      <CRow>
        <CCol
          sm="6"
          lg="6"
          style="background-size: cover; color: #fff"
          :style="{ backgroundImage: `url(${backgroundUrlNews})` }"
        >
        </CCol>
        <CCol sm="6" lg="6">
          <h1
            class="custom-pro-title display-4 mt-2 ml-5 custom-font"
            data-aos="fade-up"
          >
            News and Updates
          </h1>

          <h5
            class="custom-pro-title display-5 mt-5 ml-5 custom-font"
            data-aos="fade-up"
          >
            NEW OPPORTUNITIES
          </h5>
          <h5
            class="display-6-custom mt-2 ml-5 mr-5 custom-font"
            data-aos="fade-up"
          >
            Many tuition owner start moving their tuition centre into online
            tuition business
          </h5>

          <h5
            class="custom-pro-title display-5 mt-5 ml-5 custom-font"
            data-aos="fade-up"
          >
            THE FUTURE OF SCHOOL
          </h5>
          <h5
            class="display-6-custom mt-2 ml-5 mr-5 custom-font"
            data-aos="fade-up"
          >
            This is the new norm for many educational institutions to provide
            online platforms for their students.
          </h5>

          <h5
            class="custom-pro-title display-5 mt-5 ml-5 custom-font"
            data-aos="fade-up"
          >
            PICKIDDO PARTNER
          </h5>
          <h5
            class="display-6-custom mt-2 ml-5 mr-5 mb-5 custom-font"
            data-aos="fade-up"
          >
            Let’s be our partner and we will guide to handle your tuition and
            become an online tuition center.
          </h5>
        </CCol>
      </CRow>
    </CCol>

    <CCol style="background: #34507b" sm="12" lg="12">
      <h1 class="custom-pro-title text-center text-white">
        <br /><br />
        Subscribe our platform with minimum as low as RM300.00
      </h1>
      <CContainer>
        <CCol sm="12" lg="12" class="mt-5 mb-5 d-sm-down-none">
          <CRow>
            <CCol sm="4" lg="4">
              <br />
              <p class="text-white text-right mt-2">Pickiddo Ewallet</p>
              <p class="text-white text-right">Student Payment Integration</p>
              <p class="text-white text-right">Number of Students</p>
              <p class="text-white text-right">Number of Teachers</p>
              <p class="text-white text-right">Number of ClassRoom</p>
              <p class="text-white text-right">Number of Broadcast Messages</p>
              <p class="text-white text-right">Number of Schedules</p>
              <p class="text-white text-right">Number of Packages</p>
              <p class="text-white text-right">Number of Subjects</p>
              <p class="text-white text-right">Number of Attendance</p>
              <br /><br />
              <p class="text-white text-right">Setup Fees</p>
              <p class="text-white text-right">Per Student/hour</p>
              <p class="text-white text-right">Operation Fees</p>
            </CCol>
            <CCol
              style="background-color: #13538a"
              sm="2"
              lg="2"
              class="text-center"
            >
              <h5 class="text-white">PREMIER</h5>
              <p><CIcon name="cil-check" class="text-white" /></p>
              <p><CIcon name="cil-check" class="text-white" /></p>
              <p class="text-white"><strong>UNLIMITED</strong></p>
              <p class="text-white"><strong>UNLIMITED</strong></p>
              <p class="text-white"><strong>UNLIMITED</strong></p>
              <p class="text-white"><strong>20,000/MTH</strong></p>
              <p class="text-white"><strong>UNLIMITED</strong></p>
              <p class="text-white"><strong>UNLIMITED</strong></p>
              <p class="text-white"><strong>UNLIMITED</strong></p>
              <p class="text-white"><strong>UNLIMITED</strong></p>
              <br /><br />
              <p class="text-white"><strong>RM5,000</strong></p>
              <p class="text-white"><strong>RM2.50</strong></p>
              <p class="text-white"><strong>-</strong></p>
            </CCol>
            <CCol
              style="background-color: #2c92d5"
              sm="2"
              lg="2"
              class="text-center"
            >
              <h5 style="color: #d2c258">ADVANCE</h5>
              <p><CIcon name="cil-x" class="text-white" /></p>
              <p><CIcon name="cil-check" class="text-white" /></p>
              <p><strong>1,000</strong></p>
              <p><strong>200</strong></p>
              <p><strong>1,000</strong></p>
              <p><strong>2,000/MTH</strong></p>
              <p><strong>1,000</strong></p>
              <p><strong>1,000</strong></p>
              <p><strong>1,000</strong></p>
              <p><strong>1,500/MTH</strong></p>
              <br /><br />
              <p><strong>RM2,000</strong></p>
              <p><strong>RM2.50</strong></p>
              <p><strong>-</strong></p>
            </CCol>
            <CCol
              style="background-color: #37c9ef"
              sm="2"
              lg="2"
              class="text-center"
            >
              <h5 class="text-white">STANDARD</h5>
              <p><CIcon name="cil-x" class="text-white" /></p>
              <p><CIcon name="cil-check" class="text-white" /></p>
              <p><strong>100</strong></p>
              <p><strong>50</strong></p>
              <p><strong>200</strong></p>
              <p><strong>500/MTH</strong></p>
              <p><strong>200</strong></p>
              <p><strong>200</strong></p>
              <p><strong>200</strong></p>
              <p><strong>500/MTH</strong></p>
              <br /><br />
              <p><strong>RM500</strong></p>
              <p><strong>RM2.50</strong></p>
              <p><strong>-</strong></p>
            </CCol>
            <CCol
              style="background-color: #3edad8"
              sm="2"
              lg="2"
              class="text-center"
            >
              <h5 class="text-white">BASIC</h5>
              <p><CIcon name="cil-x" class="text-white" /></p>
              <p><CIcon name="cil-x" class="text-white" /></p>
              <p><strong>30</strong></p>
              <p><strong>5</strong></p>
              <p><strong>100</strong></p>

              <p><strong>200/MTH</strong></p>
              <p><strong>100</strong></p>
              <p><strong>50</strong></p>
              <p><strong>50</strong></p>
              <p><strong>100/MTH</strong></p>
              <br /><br />
              <p><strong>RM300</strong></p>
              <p><strong>-</strong></p>
              <p><strong>RM500/MTH</strong></p>
            </CCol>
          </CRow>
        </CCol>

        <table class="table-responsive-sm table table-striped d-md-none">
          <thead>
            <th></th>
            <th style="background-color: #13538a; color: #fff">PREMIER</th>
            <th style="background-color: #2c92d5">ADVANCE</th>
            <th style="background-color: #37c9ef">STANDARD</th>
            <th style="background-color: #3edad8">BASIC</th>
          </thead>
          <tbody>
            <tr>
              <td class="text-white">Pickiddo Ewallet</td>
              <td style="background-color: #13538a; color: #fff">
                <CIcon name="cil-check" class="text-white" />
              </td>
              <td style="background-color: #2c92d5">
                <CIcon name="cil-x" class="text-white" />
              </td>
              <td style="background-color: #37c9ef">
                <CIcon name="cil-x" class="text-white" />
              </td>
              <td style="background-color: #3edad8">
                <CIcon name="cil-x" class="text-white" />
              </td>
            </tr>

            <tr>
              <td class="text-white">Student Payment Integration</td>
              <td style="background-color: #13538a; color: #fff">
                <CIcon name="cil-check" class="text-white" />
              </td>
              <td style="background-color: #2c92d5">
                <CIcon name="cil-check" class="text-white" />
              </td>
              <td style="background-color: #37c9ef">
                <CIcon name="cil-check" class="text-white" />
              </td>
              <td style="background-color: #3edad8">
                <CIcon name="cil-x" class="text-white" />
              </td>
            </tr>

            <tr>
              <td class="text-white">Number of Students</td>
              <td style="background-color: #13538a; color: #fff">
                <p class="text-white"><strong>UNLIMITED</strong></p>
              </td>
              <td style="background-color: #2c92d5">
                <p class="text-white"><strong>1,000</strong></p>
              </td>
              <td style="background-color: #37c9ef">
                <p class="text-white"><strong>100</strong></p>
              </td>
              <td style="background-color: #3edad8">
                <p class="text-white"><strong>50</strong></p>
              </td>
            </tr>

            <tr>
              <td class="text-white">Number of Teachers</td>
              <td style="background-color: #13538a; color: #fff">
                <p class="text-white"><strong>UNLIMITED</strong></p>
              </td>
              <td style="background-color: #2c92d5">
                <p class="text-white"><strong>200</strong></p>
              </td>
              <td style="background-color: #37c9ef">
                <p class="text-white"><strong>50</strong></p>
              </td>
              <td style="background-color: #3edad8">
                <p class="text-white"><strong>5</strong></p>
              </td>
            </tr>

            <tr>
              <td class="text-white">Number of ClassRoom</td>
              <td style="background-color: #13538a; color: #fff">
                <p class="text-white"><strong>UNLIMITED</strong></p>
              </td>
              <td style="background-color: #2c92d5">
                <p class="text-white"><strong>1,000</strong></p>
              </td>
              <td style="background-color: #37c9ef">
                <p class="text-white"><strong>200</strong></p>
              </td>
              <td style="background-color: #3edad8">
                <p class="text-white"><strong>100</strong></p>
              </td>
            </tr>

            <tr>
              <td class="text-white">Number of Broadcast Messages</td>
              <td style="background-color: #13538a; color: #fff">
                <p class="text-white"><strong>20,000/MTH</strong></p>
              </td>
              <td style="background-color: #2c92d5">
                <p class="text-white"><strong>2,000/MTH</strong></p>
              </td>
              <td style="background-color: #37c9ef">
                <p class="text-white"><strong>500/MTH</strong></p>
              </td>
              <td style="background-color: #3edad8">
                <p class="text-white"><strong>200/MTH</strong></p>
              </td>
            </tr>

            <tr>
              <td class="text-white">Number of Schedules</td>
              <td style="background-color: #13538a; color: #fff">
                <p class="text-white"><strong>UNLIMITED</strong></p>
              </td>
              <td style="background-color: #2c92d5">
                <p class="text-white"><strong>1,000</strong></p>
              </td>
              <td style="background-color: #37c9ef">
                <p class="text-white"><strong>200</strong></p>
              </td>
              <td style="background-color: #3edad8">
                <p class="text-white"><strong>100</strong></p>
              </td>
            </tr>

            <tr>
              <td class="text-white">Number of Packages</td>
              <td style="background-color: #13538a; color: #fff">
                <p class="text-white"><strong>UNLIMITED</strong></p>
              </td>
              <td style="background-color: #2c92d5">
                <p class="text-white"><strong>1,000</strong></p>
              </td>
              <td style="background-color: #37c9ef">
                <p class="text-white"><strong>200</strong></p>
              </td>
              <td style="background-color: #3edad8">
                <p class="text-white"><strong>50</strong></p>
              </td>
            </tr>

            <tr>
              <td class="text-white">Number of Subjects</td>
              <td style="background-color: #13538a; color: #fff">
                <p class="text-white"><strong>UNLIMITED</strong></p>
              </td>
              <td style="background-color: #2c92d5">
                <p class="text-white"><strong>1,000</strong></p>
              </td>
              <td style="background-color: #37c9ef">
                <p class="text-white"><strong>200</strong></p>
              </td>
              <td style="background-color: #3edad8">
                <p class="text-white"><strong>50</strong></p>
              </td>
            </tr>

            <tr>
              <td class="text-white">Number of Attendance</td>
              <td style="background-color: #13538a; color: #fff">
                <p class="text-white"><strong>UNLIMITED</strong></p>
              </td>
              <td style="background-color: #2c92d5">
                <p class="text-white"><strong>1,500/MTH</strong></p>
              </td>
              <td style="background-color: #37c9ef">
                <p class="text-white"><strong>500/MTH</strong></p>
              </td>
              <td style="background-color: #3edad8">
                <p class="text-white"><strong>100/MTH</strong></p>
              </td>
            </tr>

            <tr>
              <td class="text-white">Setup Fees</td>
              <td style="background-color: #13538a; color: #fff">
                <p class="text-white"><strong>RM5,000</strong></p>
              </td>
              <td style="background-color: #2c92d5">
                <p class="text-white"><strong>RM2,000</strong></p>
              </td>
              <td style="background-color: #37c9ef">
                <p class="text-white"><strong>RM500</strong></p>
              </td>
              <td style="background-color: #3edad8">
                <p class="text-white"><strong>RM300</strong></p>
              </td>
            </tr>

            <tr>
              <td class="text-white">Per Student/hour</td>
              <td style="background-color: #13538a; color: #fff">
                <p class="text-white"><strong>RM2.50</strong></p>
              </td>
              <td style="background-color: #2c92d5">
                <p class="text-white"><strong>RM2.50</strong></p>
              </td>
              <td style="background-color: #37c9ef">
                <p class="text-white"><strong>RM2.50</strong></p>
              </td>
              <td style="background-color: #3edad8">
                <p class="text-white"><strong>-</strong></p>
              </td>
            </tr>
            <tr>
              <td class="text-white">Operation Fees</td>
              <td style="background-color: #13538a; color: #fff">
                <p class="text-white"><strong>-</strong></p>
              </td>
              <td style="background-color: #2c92d5">
                <p class="text-white"><strong>-</strong></p>
              </td>
              <td style="background-color: #37c9ef">
                <p class="text-white"><strong>-</strong></p>
              </td>
              <td style="background-color: #3edad8">
                <p class="text-white"><strong>RM500/MTH</strong></p>
              </td>
            </tr>
          </tbody>
        </table>
        <br /><br /><br />
      </CContainer>
    </CCol>

    <CCol
      :style="{ backgroundImage: `url(${backgroundUrlContact})` }"
      sm="12"
      lg="12"
    >
      <div style="background: #233dff" class="bottom-top">
        <h1 class="ml-2 mr-2" data-aos="fade-up">Contact Information</h1>
      </div>
      <br />
      <br />
      <br />
      <CContainer class="mt-5">
        <CCol sm="12" lg="12" class="mt-5">
          <CRow>
            <CCol sm="4" lg="4">
              <CInput type="text" size="lg" placeholder="Name" v-model="Name"/>
              <CInput type="text" size="lg" placeholder="Telephone No" v-model="PhoneNumber" />
              <CInput type="text" size="lg" placeholder="Email" v-model="Email" />
            </CCol>
            <CCol sm="8" lg="8">
              <CTextarea vertical placeholder="Message" rows="7" v-model="Message"/>
            </CCol>
          </CRow>
          <h5 class="mt-5 display-5 text-white mb-5 text-center">
            Please provide these info and our team will contact you
          </h5>
          <br />
        </CCol>
      </CContainer>
    </CCol>

    <CCol style="bacground-color: rgb(240, 240, 240)" sm="12" lg="12">
      <CCol sm="12" lg="12">
        <CRow>
          <CCol sm="3" lg="3">
            <h5 class="custom-pro-title mt-5 text-left" data-aos="fade-up">
              EMAIL ADDRESS
            </h5>
            <h5>admin@pickiddo.com</h5>
          </CCol>
          <CCol sm="3" lg="3">
            <h5 class="mt-5 custom-pro-title">MAILING ADDRESS</h5>
            <h3 class="display-6">
              The Square@One City, T1-14-13,Jalan USJ25/1C,47650 UEP Subang
              Jaya, Selangor Darul Ehsan, Malaysia
            </h3>
          </CCol>
          <CCol sm="3" lg="3">
            <h5 class="mt-5 custom-pro-title">PHONE NUMBER</h5>
            <h3 class="display-6">(010)659-7700</h3>
          </CCol>
          <CCol sm="3" lg="3">
            <CButton
              color="primary"
              class="mt-5"
              size="lg"
              style="width: 200px; height: 70px"
              @click="InsertPartner"
              >SUBMIT</CButton
            >
          </CCol>
        </CRow>
      </CCol>
    </CCol>
  </div>
</template>

<script>


import Vue from "vue";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";




import backgroundUrl from "../../assets/img/bgSkill.png";
import backgroundBanner from "../../assets/img/bg231.png";
import backgroundBannerUrl from "../../assets/img/bg4.png";
import backgroundBannerReg from "../../assets/img/bgReg.jpg";
import backgroundUrlNews from "../../assets/img/update.jpg";
import backgroundUrlContact from "../../assets/img/bgcontact.png";
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "ProClass",
  data() {
    return {
      backgroundUrl,
      backgroundBanner,
      backgroundBannerUrl,
      backgroundBannerReg,
      backgroundUrlNews,
      backgroundUrlContact,

      // Name,
      // PhoneNumber,
      // Email,
      // Message,
    };
  },
  created() {
    AOS.init();
  },
  methods: {
    InsertPartner() {
      const formData = new FormData();

      formData.append("Name", this.Name);
      formData.append("Email", this.Email);
      formData.append("PhoneNumber", this.PhoneNumber);
       formData.append("Message", this.Message);

      return this.$API
        .post(this.$RegisterPartner, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.$dialog.alert("You have successfully save data").then(function (dialog) {
                console.log("Closed");
              });
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
  },
};
</script>

<style>
body {
  background: #fff;
}
.carousel-indicators li {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #000015;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  -webkit-transition: opacity 0.6s ease;
  transition: opacity 0.6s ease;
}

.custom-font {
  font-family: "Rubik", sans-serif;
}

.change_color {
  background-color: red;
}

* {
  padding: 0;
  margin: 0;
}

body {
  height: 100vh;
}
body nav {
  position: fixed;
  width: 100%;
  height: 70px;
  background-color: transparent;
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
}
body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}

.c-header {
  background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83;
  /* color: #fff; */
}

@import url("https://fonts.googleapis.com/css2?family=Rubik:wght@300&display=swap");
</style>

